export default "__VITE_ASSET__78ceef6c__"